import type { UserManagementType } from "@/redux/userManagement/userManagementTypes";

export const userManagementReducer = {
  resetUserManagementFetching: (state: UserManagementType) => {
    state.fetching = false;
  },
  resetUserManagementError: (state: UserManagementType) => {
    state.error = null;
  },
  resetUserManagementSuccess: (state: UserManagementType) => {
    state.success = null;
  },
  resetUserManagementStatusCode: (state: UserManagementType) => {
    state.statusCode = null;
  },
  resetSideMenuList: (state: UserManagementType) => {
    state.sideMenuList = [];
  },
  resetModulesList: (state: UserManagementType) => {
    state.moduleList = [];
  },
  resetOthersList: (state: UserManagementType) => {
    state.othersList = [];
  },
  resetUserGroupList: (state: UserManagementType) => {
    state.userGroupList = [];
  },
  resetGroupName: (state: UserManagementType) => {
    state.group_name = "";
  },
  resetGroupMenu: (state: UserManagementType) => {
    state.group_menu = [];
  },
  resetEditUserGroupData: (state: UserManagementType) => {
    state.editUserGroupData.group_menu = [];
    state.editUserGroupData.group_name = "";
  },
  resetUserGroupCount: (state: UserManagementType) => {
    state.userGroupCount = 0;
  },
  resetAssignedGroupListCount: (state: UserManagementType) => {
    state.assignedGroupListCount = 0;
  },
};
